<template>
    <x-page title="Dashboard">
        <p>
            Selamat datang {{ loggedUser && loggedUser.name }}!
            <br />
            <span class="visible-xs">
                Klik tombol <i class="fa fa-bars" /> dan pilih salah satu menu
                yang ada.
            </span>
            <span class="hidden-xs">
                Silahkan pilih salah satu menu di sebelah kiri.
            </span>
        </p>

        <div class="row">
            <div class="col-xs-12 col-md-6" v-if="can('viewMembers')">
                <x-panel title="Jemaat yang berulang tahun hari ini">
                    <x-table
                        :headers="['#', 'Nama Lengkap', 'Group']"
                        :is-loading="isLoading"
                    >
                        <tr v-for="(resource, index) in members" :key="index">
                            <td>{{ rowIndex(index) }}</td>
                            <td class="nowrap">
                                <router-link
                                    :to="`/admin/members/${resource.id}`"
                                    title="Klik untuk lihat detail"
                                >
                                    {{ resource.name }}
                                </router-link>
                            </td>
                            <td class="nowrap">
                                <template
                                    v-for="(group, index) in resource.groups"
                                >
                                    <router-link
                                        :key="index"
                                        :to="`/admin/groups/${group.id}`"
                                        >{{ group.label }}</router-link
                                    ><span
                                        :key="`comma-${index}`"
                                        v-show="
                                            index < resource.groups.length - 1
                                        "
                                        >,
                                    </span>
                                </template>
                            </td>
                        </tr>
                        <template #empty-text
                            >Tidak ada yang berulang tahun hari ini</template
                        >
                    </x-table>
                </x-panel>
            </div>
            <div class="col-xs-12 col-md-6">
                <x-panel title="Rekapan Jumlah Jemaat">
                    <div class="table-responsive">
                        <table class="table table-condensed table-bordered">
                            <tbody>
                                <tr>
                                    <th>Jumlah Pengguna Aplikasi</th>
                                    <td>{{ users_count | number }}</td>
                                </tr>
                                <tr>
                                    <th>Jumlah Jemaat Aktif</th>
                                    <td>{{ active_members_count | number }}</td>
                                </tr>
                                <tr>
                                    <th>Jumlah Jemaat Tidak Aktif</th>
                                    <td>
                                        {{ inactive_members_count | number }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Jumlah Calon Jemaat</th>
                                    <td>{{ draft_members_count | number }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </x-panel>
                <x-panel
                    title="Jumlah Anggota Group Berdasarkan Kategori"
                    v-if="can('viewGroupCategories')"
                >
                    <div class="table-responsive">
                        <table class="table table-condensed table-bordered">
                            <tbody>
                                <tr
                                    v-for="(category, index) in groupCategories"
                                    :key="index"
                                >
                                    <th>{{ category.label }}</th>
                                    <td>
                                        {{ category.members_count | number }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </x-panel>
            </div>
        </div>
    </x-page>
</template>

<script>
import XPage from "../../components/XPage.vue";
import XPanel from "../../components/XPanel.vue";
import XTable from "../../components/XTable.vue";
import { handleGeneralXhrError } from "../../helpers";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";

export default {
    async created() {
        await this.fetchProfile();
        if (this.can("viewMembers")) {
            await this.fetchMembers();
        }
        await this.fetchMemberAnalytics();
        if (this.can("viewGroupCategories")) {
            await this.fetchGroupCategories();
        }
    },
    components: {
        XPage,
        XTable,
        XPanel,
    },
    data() {
        return {
            active_members_count: 0,
            draft_members_count: 0,
            groupCategories: [],
            inactive_members_count: 0,
            isLoading: false,
            loggedUser: null,
            members: [],
            users_count: 0,
        };
    },
    methods: {
        fetchGroupCategories() {
            this.isLoading = true;
            const request = axios
                .get("/api/group-categories", {
                    params: {
                        with_members_count: 1,
                        limit: Number.MAX_SAFE_INTEGER,
                    },
                })
                .then((response) => {
                    this.groupCategories = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchMemberAnalytics() {
            this.isLoading = true;
            const request = axios
                .get("/api/dashboard/member-analytics")
                .then((response) => {
                    const data = response.data;
                    this.active_members_count = data.active_members_count;
                    this.draft_members_count = data.draft_members_count;
                    this.inactive_members_count = data.inactive_members_count;
                    this.users_count = data.users_count;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchMembers() {
            this.isLoading = true;
            const request = axios
                .get("/api/members", {
                    params: {
                        having_birthday: 1,
                        limit: Number.MAX_SAFE_INTEGER,
                        with: "groups",
                    },
                })
                .then((response) => {
                    this.members = response.data.data;
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        fetchProfile() {
            this.isLoading = true;
            const request = axios.get("/api/profile").then((response) => {
                this.loggedUser = response.data.data;
            });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [PaginationMixin, PermissionMixin],
};
</script>
